import { useDispatch } from 'react-redux';
import { showAlert } from '../../../../../features/slices/applicationSlice';
import { TFunction } from 'i18next';

const useAlerts = ({ translate }: { translate: ((key: string) => string) | TFunction }) => {
    const dispatch = useDispatch();

    const showConfirmCreateEquipmentAlert = ({ confirmAction, cancelAction }: any) => {
        dispatch(
            showAlert({
                title: translate('alerts.create.title'),
                message: translate('alerts.create.message'),
                icon: 'info',
                confirmText: translate('alerts.create.confirmText'),
                cancelText: translate('alerts.create.cancelText'),
                confirmAction: confirmAction,
                cancelAction: cancelAction
            })
        );
    };

    const showConfirmEditEquipmentAlert = ({ confirmAction, cancelAction }: any) => {
        dispatch(
            showAlert({
                title: translate('alerts.edit.title'),
                message: translate('alerts.edit.message'),
                icon: 'info',
                confirmText: translate('alerts.edit.confirmText'),
                cancelText: translate('alerts.edit.cancelText'),
                confirmAction: confirmAction,
                cancelAction: cancelAction || null
            })
        );
    };

    const showConfirmDeleteEquipmentAlert = ({ confirmAction, cancelAction }: any) => {
        dispatch(
            showAlert({
                title: translate('alerts.delete.title'),
                message: translate('alerts.delete.message'),
                icon: 'error',
                confirmText: translate('alerts.delete.confirmText'),
                cancelText: translate('alerts.delete.cancelText'),
                confirmAction: confirmAction,
                cancelAction: cancelAction || null
            })
        );
    };

    const showConfirmCreateResponsibleAlert = ({ confirmAction, cancelAction }: any) => {
        dispatch(
            showAlert({
                title: translate('alerts.createResponsible.title'),
                message: translate('alerts.createResponsible.message'),
                icon: 'info',
                confirmText: translate('alerts.createResponsible.confirmText'),
                cancelText: translate('alerts.createResponsible.cancelText'),
                confirmAction: confirmAction,
                cancelAction: cancelAction
            })
        );
    };

    const showConfirmDeleteResponsibleAlert = ({ confirmAction, cancelAction }: any) => {
        dispatch(
            showAlert({
                title: translate('alerts.delete.title'),
                message: translate('alerts.delete.message'),
                icon: 'error',
                confirmText: translate('alerts.delete.confirmText'),
                cancelText: translate('alerts.delete.cancelText'),
                confirmAction: confirmAction,
                cancelAction: cancelAction || null
            })
        );
    };

    const closeWithoutSavingAlert = ({ confirmAction }: any) => {
        dispatch(
            showAlert({
                title: translate('alerts.closeWithoutSaving.title'),
                message: translate('alerts.closeWithoutSaving.message'),
                icon: 'info',
                confirmText: translate('alerts.closeWithoutSaving.confirmText'),
                cancelText: translate('alerts.closeWithoutSaving.cancelText'),
                confirmAction: confirmAction,
                cancelAction: null
            })
        );
    };

    return {
        showConfirmCreateEquipmentAlert,
        showConfirmEditEquipmentAlert,
        showConfirmDeleteEquipmentAlert,
        showConfirmCreateResponsibleAlert,
        showConfirmDeleteResponsibleAlert,
        closeWithoutSavingAlert
    };
};

export default useAlerts;
